import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { formatPercent } from "../../lib";

type Row = {
  drafts_total: number | null;
  jobs_this_month: number | null;
  jobs_this_week: number | null;
  total_filled_ytd: number | null;
  total_posted_ytd: number | null;
};

// Aggregate school_admin stats from GET /api/stats/school-admin. school_admin
// → rolled up across schools they admin; superuser → all schools. Pass
// ?id=<school_id> to scope to a single school.
export const school_admin_stats: Query<Ctx> = async ({ sb }, params) => {
  const schoolId = params.get("id");
  const path = schoolId
    ? `api/stats/school-admin?id=${encodeURIComponent(schoolId)}`
    : "api/stats/school-admin";

  const { data, error } = await sb.functions.invoke<Row | null>(path, {
    method: "GET",
  });
  if (error) console.error("school_admin_stats:", error);

  const drafts_total = Number(data?.drafts_total ?? 0);
  const jobs_this_month = Number(data?.jobs_this_month ?? 0);
  const jobs_this_week = Number(data?.jobs_this_week ?? 0);
  const total_filled_ytd = Number(data?.total_filled_ytd ?? 0);
  const total_posted_ytd = Number(data?.total_posted_ytd ?? 0);

  const fill_rate_ytd =
    total_posted_ytd > 0 ? total_filled_ytd / total_posted_ytd : null;

  return {
    drafts_total,
    jobs_this_month,
    jobs_this_week,
    fill_rate_ytd,
    f_fill_rate_ytd: formatPercent(fill_rate_ytd),
    total_filled_ytd,
    total_posted_ytd,
  };
};
